import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Hankkeet from './pages/Hankkeet';
import Tuotannot from './pages/Tuotannot';
import Referenssit from './pages/Referenssit';
import Tuotantopalvelut from './pages/Tuotantopalvelut';
import Yhteystiedot from './pages/Yhteystiedot';
import ElamyksiaVesilla from './pages/ElamyksiaVesilla';
import SodanJaljet from './pages/SodanJaljet';
import TuotantopalveluSubpage from './pages/TuotantopalveluSubpage';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <div className="parallax-container">
          <div className="parallax-background"></div>
          <div className="parallax-content">
            <div className="page-content-wrapper">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/tuotantopalvelut" element={<Tuotantopalvelut />} />
                <Route path="/tuotantopalvelut/:serviceId" element={<TuotantopalveluSubpage />} />
                <Route path="/tuotannot" element={<Tuotannot />} />
                <Route path="/hankkeet" element={<Hankkeet />} />
                <Route path="/tuotannot/elamyksia-vesilla" element={<ElamyksiaVesilla />} />
                <Route path="/tuotannot/sodan-jaljet" element={<SodanJaljet />} />
                <Route path="/referenssit" element={<Referenssit />} />
                <Route path="/yhteystiedot" element={<Yhteystiedot />} />
              </Routes>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;
